export const notificationDefinitions = {
    /* ── الشات ──────────────────────────────────────────────────────────── */
    /**
     * **ومن أُشير إليه يُبلَّغ** — وزمنُ ردّه يُقاس من هذه اللحظة.
     *
     * وقرارُ شادي: الإشارةُ غيرُ المجابة **تُراكِم وتجرّ المتوسطَ لأسفل حتى
     * تُجاب** — فلا يختفي التأخيرُ بتجاهله.
     */
    "chat.mentioned": {
        titleKey: "notify.chat.mentioned.title",
        bodyKey: "notify.chat.mentioned.body",
        link: "/chat/{id}",
        params: ["channel", "excerpt"],
    },
    /**
     * **وكلامُ العميل يصل مديرَ حسابه والإدارة** (قرار شادي) — لا فريقَه.
     *
     * فجمهورُه قدرةُ الردّ نفسُها، **وهي بنطاق «عميلٌ يديره»**: فيُحسَب الجمهورُ
     * بنطاقها فلا يبلغ من لا يحقّ له.
     */
    "chat.portalMessage": {
        titleKey: "notify.chat.portalMessage.title",
        bodyKey: "notify.chat.portalMessage.body",
        link: "/chat/{id}",
        params: ["client", "excerpt"],
    },
    /**
     * **وردُّ الوكالة يصل العميلَ** — بهوية الوكالة، فلا اسمَ موظّفٍ في نصّه.
     *
     * **ورابطُه يصل الرسالةَ بعينها** لا شاشةَ المحادثة: فخيطٌ فيه خمسون رسالة
     * يجعل صاحبَه يبحث عن الردّ الذي أُبلِغ به — **وهو «رابطٌ يفتح قائمة»**.
     */
    /**
     * **وقناةٌ قربت تُطوى** — فمن أراد إبقاءها يكتب فيها.
     *
     * **ورابطُه يصل القناةَ نفسَها** — فالفعلُ المطلوب أن يُكتَب فيها، لا أن
     * يُبحَث عنها في قائمة.
     */
    "chat.foldSoon": {
        titleKey: "notify.chat.foldSoon.title",
        bodyKey: "notify.chat.foldSoon.body",
        link: "/chat/{id}",
        params: ["channel", "days"],
    },
    "chat.portalReply": {
        titleKey: "notify.chat.portalReply.title",
        bodyKey: "notify.chat.portalReply.body",
        link: "/portal/chat/{id}",
        params: ["excerpt"],
    },
    /* ── الاجتماعات ─────────────────────────────────────────────────────── */
    /**
     * **وطلبُ العميل يصل مديرَ حسابه** — فهو من يبتّ فيه، والإدارةُ خلفه.
     *
     * **والرابطُ يصل صفَّ الاجتماع** لا قائمةَ الاجتماعات: فمن أُبلِغ بطلبٍ يحتاج
     * **أن يردّ عليه**، لا أن يبحث عنه بين عشرين موعداً.
     */
    "meeting.requested": {
        titleKey: "notify.meeting.requested.title",
        bodyKey: "notify.meeting.requested.body",
        link: "/meetings/{id}",
        params: ["client", "when"],
    },
    /**
     * **واقتراحُ الوكالة يصل العميلَ** — ولا يحمل رابطَ الغرفة.
     *
     * **فالرابطُ محجوبٌ حتى التأكيد** (§3): ونصُّ الإشعار يقول الموعدَ ويطلب
     * الردّ، **ولو حمل الرابطَ لالتفَّ على الحجب كلِّه** — يصل في بريدٍ ويُفتَح
     * على غرفةٍ فارغة.
     */
    "meeting.proposed": {
        titleKey: "notify.meeting.proposed.title",
        bodyKey: "notify.meeting.proposed.body",
        link: "/portal/meetings/{id}",
        params: ["when"],
    },
    /** **والتأكيدُ يصل الطرفين** — ومعه الموعد، فيُكتَب في التقويم */
    "meeting.confirmed": {
        titleKey: "notify.meeting.confirmed.title",
        bodyKey: "notify.meeting.confirmed.body",
        link: "/meetings/{id}",
        params: ["when"],
    },
    /** **والرفضُ بسببه** — فمن رُفض موعدُه يعرف لماذا، ويقترح غيره */
    "meeting.rejected": {
        titleKey: "notify.meeting.rejected.title",
        bodyKey: "notify.meeting.rejected.body",
        link: "/meetings/{id}",
        params: ["reason"],
    },
    /**
     * **والإلغاءُ خطورتُه أعلى** — فموعدٌ مؤكَّدٌ يُلغى يُفرِغ ساعةً في يوم إنسان.
     */
    "meeting.cancelled": {
        titleKey: "notify.meeting.cancelled.title",
        bodyKey: "notify.meeting.cancelled.body",
        link: "/meetings/{id}",
        params: ["when", "reason"],
    },
    /**
     * **وتذكيرٌ قبل ساعةٍ وقبل خمس دقائق** — وكان ذلك صحيحاً في v2 فيُحفَظ.
     *
     * **والأوّلُ ليُرتِّب، والثاني ليدخل**: فتذكيرُ الساعة يسمح بإنهاء ما في اليد،
     * وتذكيرُ الخمس دقائق هو الذي يُدخِل الغرفة. وواحدٌ منهما وحده لا يكفي.
     */
    "meeting.reminderHour": {
        titleKey: "notify.meeting.reminderHour.title",
        bodyKey: "notify.meeting.reminderHour.body",
        link: "/meetings/{id}",
        params: ["when"],
    },
    "meeting.reminderSoon": {
        titleKey: "notify.meeting.reminderSoon.title",
        bodyKey: "notify.meeting.reminderSoon.body",
        link: "/meetings/{id}",
        params: ["when"],
    },
    /* ── المنصة ─────────────────────────────────────────────────────────── */
    /**
     * **ونسخةٌ نُشرت** — فالفريقُ يعرف الجديدَ في النظام الذي يشتغل عليه.
     *
     * **ورابطُه يصل الإصدارَ بعينه** لا سجلَّ النسخ: فمن أُبلِغ بنسخةٍ يريد أن
     * يقرأ **ما فيها**، لا أن يدوّر في أرشيف.
     *
     * **ويُبلَّغ مرّةً**: الحدثُ على النشر وحده (انتقالٌ لا حالة) — فنسخةٌ تُعدَّل
     * بعد نشرها لا تُعاد، **وتصحيحُها إصدارٌ جديدٌ برقمه**.
     */
    "platform.release.published": {
        titleKey: "notify.platform.release.title",
        bodyKey: "notify.platform.release.body",
        link: "/releases/{id}",
        params: ["version"],
    },
    /* ── التحليلات والأهداف ─────────────────────────────────────────────── */
    /**
     * **وعلى الانتقال وحده** (قرار شادي): بلغَ فأُبلِغ مرّةً، كُسر فأُبلِغ مرّةً.
     *
     * فالصفُّ يحفظ حالتَه المقيسةَ الأخيرة، **وإشعارٌ على كل قياسٍ نقٌّ يوميٌّ
     * يُكتَم** — ومن كتم إشعاراتِ الأهداف لن يرى كسرَ الهدف الذي يهمّه.
     */
    "analytics.goalAchieved": {
        titleKey: "notify.analytics.goalAchieved.title",
        bodyKey: "notify.analytics.goalAchieved.body",
        link: "/analytics/goals/{id}",
        params: ["metric", "value", "target"],
    },
    "analytics.goalBreached": {
        titleKey: "notify.analytics.goalBreached.title",
        bodyKey: "notify.analytics.goalBreached.body",
        link: "/analytics/goals/{id}",
        params: ["metric", "value", "target"],
    },
    /* ── التقارير ───────────────────────────────────────────────────────── */
    /** **ومن يراجع يُبلَّغ** — فتقريرٌ مرفوعٌ لا يعرف به أحدٌ يقف */
    "reports.submitted": {
        titleKey: "notify.reports.submitted.title",
        bodyKey: "notify.reports.submitted.body",
        link: "/reports/{id}",
        params: ["title"],
    },
    "reports.reviewed": {
        titleKey: "notify.reports.reviewed.title",
        bodyKey: "notify.reports.reviewed.body",
        link: "/reports/{id}",
        params: ["title", "outcome"],
    },
    /** **وبها يصل العميلَ** — فهو الحدثُ الذي يعنيه */
    "reports.published": {
        titleKey: "notify.reports.published.title",
        bodyKey: "notify.reports.published.body",
        link: "/reports/{id}",
        params: ["title", "outcome"],
    },
    /**
     * **وطلبُ العميل تعديلاً يصل كاتبَه ورئيسَ قسمه.**
     *
     * **ولا يصل الإدارةَ** — فليس قراراً بل تصحيحٌ يُنفَّذ: من يكتب يصحّح، ومن
     * يراجع يعلم. والإدارةُ تراه حين تصلها النسخةُ الجديدة.
     */
    "reports.editRequested": {
        titleKey: "notify.reports.editRequested.title",
        bodyKey: "notify.reports.editRequested.body",
        link: "/reports/{id}",
        params: ["title", "reason"],
    },
    "reports.exceptionRequested": {
        titleKey: "notify.reports.exceptionRequested.title",
        bodyKey: "notify.reports.exceptionRequested.body",
        link: "/report-exceptions/{id}",
        params: ["reason"],
    },
    "reports.exceptionDecided": {
        titleKey: "notify.reports.exceptionDecided.title",
        bodyKey: "notify.reports.exceptionDecided.body",
        link: "/report-exceptions/{id}",
        params: ["decision"],
    },
    /* ── الوساطة والنشر ─────────────────────────────────────────────────── */
    /** **وهو ما ينتظره العميل** — ومنه يصير عنصرُه منتهياً حين تكتمل صفوفُه */
    "moderation.published": {
        titleKey: "notify.moderation.published.title",
        bodyKey: "notify.moderation.published.body",
        link: "/plans/{id}",
        /** **وقيمةٌ بلا مصدرٍ تُطبَع بأقواسها** — ويمسكها حارسُ قيم الإشعار */
        params: ["title", "platform"],
    },
    /** **وسحبُ الوسم يُقال لصاحبه** — كان «اتنشر» فصار «لأ»، ولا يُكتشَف بالصدفة */
    "moderation.unpublished": {
        titleKey: "notify.moderation.unpublished.title",
        bodyKey: "notify.moderation.unpublished.body",
        link: "/plans/{id}",
        params: ["title", "reason"],
    },
    /** **ودقائقُ طلب الإزالة تُحسَب** — فيصل إلى من يملك إقفاله فوراً */
    "moderation.takedownRequested": {
        titleKey: "notify.moderation.takedownRequested.title",
        bodyKey: "notify.moderation.takedownRequested.body",
        /**
         * **ويصل إلى الطلب نفسه، لا إلى الطابور.**
         *
         * وكتبتُه `/moderation` أوّلاً **فأمسكته البوابة**: «كل رابط عميق يصل إلى
         * صفّ، لا إلى قائمة يبحث فيها صاحبه». ومن يُبلَّغ بطلب إزالةٍ عاجل آخرُ ما
         * يحتاجه أن يفتح طابوراً بمئة صفٍّ ليدوّر على واحد.
         */
        link: "/moderation/takedowns/{id}",
        params: ["title", "platform"],
    },
    "moderation.takedownResolved": {
        titleKey: "notify.moderation.takedownResolved.title",
        bodyKey: "notify.moderation.takedownResolved.body",
        link: "/plans/{id}",
        params: ["title", "resolution"],
    },
    "tasks.task.assigned": {
        titleKey: "notify.tasks.assigned.title",
        bodyKey: "notify.tasks.assigned.body",
        link: "/tasks/{id}",
    },
    "tasks.task.updated": {
        titleKey: "notify.tasks.updated.title",
        bodyKey: "notify.tasks.updated.body",
        link: "/tasks/{id}",
    },
    "tasks.task.state_changed": {
        titleKey: "notify.tasks.stateChanged.title",
        bodyKey: "notify.tasks.stateChanged.body",
        link: "/tasks/{id}",
    },
    /**
     * **أحداثُ الخيوط الجديدة** (قرار شادي 2026-10-20) — ولكلٍّ نصٌّ ورابط.
     *
     * **ورابطٌ يفتح السجلَّ نفسَه لا قائمتَه**: فإشعارٌ يفتح قائمةً يُجبر قارئَه
     * أن يبحث عمّا أُشعِر به — وهو درسُ الروابط العميقة بعينه.
     */
    "reports.comment.added": {
        titleKey: "notify.reports.commented.title",
        bodyKey: "notify.reports.commented.body",
        link: "/reports/{id}",
        params: ["title"],
    },
    "meetings.comment.added": {
        titleKey: "notify.meetings.commented.title",
        bodyKey: "notify.meetings.commented.body",
        link: "/meetings/{id}",
        params: ["subject"],
    },
    /** **ومن أُضيف إلى الحضور يُعلَم** — فحضورٌ يُفرَض بلا خبرٍ موعدٌ يفوت */
    "meetings.attendee.added": {
        titleKey: "notify.meetings.attendee.title",
        bodyKey: "notify.meetings.attendee.body",
        link: "/meetings/{id}",
        params: ["subject"],
    },
    "tasks.comment.added": {
        titleKey: "notify.tasks.commented.title",
        bodyKey: "notify.tasks.commented.body",
        link: "/tasks/{id}",
    },
    "platform.setting.changed": {
        titleKey: "notify.platform.settingChanged.title",
        bodyKey: "notify.platform.settingChanged.body",
        link: "/settings",
    },
    "roles.matrix.replaced": {
        titleKey: "notify.roles.matrixReplaced.title",
        bodyKey: "notify.roles.matrixReplaced.body",
        link: "/roles/{id}",
    },
    "identity.role.assigned": {
        titleKey: "notify.identity.roleAssigned.title",
        bodyKey: "notify.identity.roleAssigned.body",
        link: "/people/{id}",
    },
    "identity.override.created": {
        titleKey: "notify.identity.overrideCreated.title",
        bodyKey: "notify.identity.overrideCreated.body",
        link: "/people/{id}",
    },
    /**
     * ويُبلَّغ صاحبه **في الحالتين** — رفعُ منعٍ أو رفعُ منح.
     *
     * في v2 كان رفعُ المنع — أي **إعادة** قدرة — لا يُبلَّغ به أحد، فمن رُدّت
     * إليه صلاحية لا يعرف أنها ردّت.
     */
    "identity.override.removed": {
        titleKey: "notify.identity.overrideRemoved.title",
        bodyKey: "notify.identity.overrideRemoved.body",
        link: "/people/{id}",
    },
    "identity.user.created": {
        titleKey: "notify.identity.userCreated.title",
        bodyKey: "notify.identity.userCreated.body",
        link: "/people/{id}",
    },
    "identity.user.deactivated": {
        titleKey: "notify.identity.userDeactivated.title",
        bodyKey: "notify.identity.userDeactivated.body",
        link: "/people/{id}",
    },
    "identity.user.reactivated": {
        titleKey: "notify.identity.userReactivated.title",
        bodyKey: "notify.identity.userReactivated.body",
        link: "/people/{id}",
    },
    "identity.password.reset": {
        titleKey: "notify.identity.passwordReset.title",
        bodyKey: "notify.identity.passwordReset.body",
        link: "/people/{id}",
    },
    "identity.sessions.revoked": {
        titleKey: "notify.identity.sessionsRevoked.title",
        bodyKey: "notify.identity.sessionsRevoked.body",
        link: "/people/{id}",
    },
    "org.department.head_changed": {
        titleKey: "notify.org.headChanged.title",
        bodyKey: "notify.org.headChanged.body",
        link: "/departments/{id}",
    },
    "org.delegation.granted": {
        titleKey: "notify.org.delegationGranted.title",
        bodyKey: "notify.org.delegationGranted.body",
        link: "/departments/{id}",
    },
    "org.delegation.revoked": {
        titleKey: "notify.org.delegationRevoked.title",
        bodyKey: "notify.org.delegationRevoked.body",
        link: "/departments/{id}",
    },
    "access_requests.created": {
        titleKey: "notify.access.created.title",
        bodyKey: "notify.access.created.body",
        link: "/access-requests/{id}",
    },
    "access_requests.resolved": {
        titleKey: "notify.access.resolved.title",
        bodyKey: "notify.access.resolved.body",
        link: "/access-requests/{id}",
    },
    "clients.client.created": {
        titleKey: "notify.clients.created",
        bodyKey: "notify.clients.createdBody",
        link: "/clients/{id}",
    },
    "clients.member.added": {
        titleKey: "notify.clients.memberAddedTitle",
        bodyKey: "notify.clients.memberAddedBody",
        link: "/clients/{id}/team",
    },
    "clients.member.removed": {
        titleKey: "notify.clients.memberRemovedTitle",
        bodyKey: "notify.clients.memberRemovedBody",
        link: "/clients/{id}/team",
    },
    "clients.account_manager.set": {
        titleKey: "notify.clients.managerTitle",
        bodyKey: "notify.clients.managerBody",
        link: "/clients/{id}/team",
    },
    "clients.client.archived": {
        titleKey: "notify.clients.archivedTitle",
        bodyKey: "notify.clients.archivedBody",
        link: "/clients/{id}",
    },
    "clients.client.restored": {
        titleKey: "notify.clients.restoredTitle",
        bodyKey: "notify.clients.restoredBody",
        link: "/clients/{id}",
    },
    "clients.export.requested": {
        titleKey: "notify.clients.exportTitle",
        bodyKey: "notify.clients.exportBody",
        link: "/clients/{id}",
    },
    /**
     * **ورابطُه إلى شاهدة الحذف، لا إلى قائمة العملاء.**
     *
     * أمسكته بوابةُ «كل رابط يصل إلى صفّ». والعميل ذهب، فلا صفّ له يُفتَح — لكن
     * شاهدتَه في السجلّ الجنائي باقية، وهي ما يريده من يقرأ الإشعار: من حذف ومتى
     * وبأمر من. وإسقاطُه على قائمة العملاء يترك صاحبه يبحث عمّا لم يعد موجوداً.
     */
    "clients.client.deleted": {
        titleKey: "notify.clients.deletedTitle",
        bodyKey: "notify.clients.deletedBody",
        link: "/audit/clients/{id}",
    },
    "clients.quota.changed": {
        titleKey: "notify.clients.quotaTitle",
        bodyKey: "notify.clients.quotaBody",
        link: "/clients/{id}",
    },
    "clients.quota.threshold": {
        titleKey: "notify.clients.quotaThresholdTitle",
        bodyKey: "notify.clients.quotaThresholdBody",
        link: "/clients/{id}",
        params: ["percent", "block"],
    },
    "clients.archive.reminder": {
        titleKey: "notify.clients.archiveReminderTitle",
        bodyKey: "notify.clients.archiveReminderBody",
        link: "/clients/{id}",
        params: ["weeks"],
    },
    "boards.board.archived": {
        titleKey: "notify.boards.archivedTitle",
        bodyKey: "notify.boards.archivedBody",
        link: "/boards/{id}",
    },
    "cards.card.assigned": {
        titleKey: "notify.cards.assignedTitle",
        bodyKey: "notify.cards.assignedBody",
        link: "/cards/{id}",
    },
    "cards.card.updated": {
        titleKey: "notify.cards.updatedTitle",
        bodyKey: "notify.cards.updatedBody",
        link: "/cards/{id}",
    },
    "cards.card.moved": {
        titleKey: "notify.cards.movedTitle",
        bodyKey: "notify.cards.movedBody",
        link: "/cards/{id}",
    },
    "cards.card.state_changed": {
        titleKey: "notify.cards.stateTitle",
        bodyKey: "notify.cards.stateBody",
        link: "/cards/{id}",
    },
    "cards.card.archived": {
        titleKey: "notify.cards.archivedTitle",
        bodyKey: "notify.cards.archivedBody",
        link: "/cards/{id}",
    },
    "cards.card.restored": {
        titleKey: "notify.cards.restoredTitle",
        bodyKey: "notify.cards.restoredBody",
        link: "/cards/{id}",
    },
    "cards.comment.added": {
        titleKey: "notify.cards.commentTitle",
        bodyKey: "notify.cards.commentBody",
        link: "/cards/{id}",
    },
    "cards.comment.mentioned": {
        titleKey: "notify.cards.mentionTitle",
        bodyKey: "notify.cards.mentionBody",
        link: "/cards/{id}",
    },
    "cards.due.requested": {
        titleKey: "notify.cards.dueRequestedTitle",
        bodyKey: "notify.cards.dueRequestedBody",
        link: "/cards/{id}",
    },
    "cards.due.decided": {
        titleKey: "notify.cards.dueDecidedTitle",
        bodyKey: "notify.cards.dueDecidedBody",
        link: "/cards/{id}",
    },
    "cards.due.changed": {
        titleKey: "notify.cards.dueChangedTitle",
        bodyKey: "notify.cards.dueChangedBody",
        link: "/cards/{id}",
    },
    "cards.reminder.due": {
        titleKey: "notify.cards.reminderTitle",
        bodyKey: "notify.cards.reminderBody",
        link: "/cards/{id}",
    },
    /**
     * **والمتأخّرُ يُقال متأخّراً** — لا «موعده قرّب».
     *
     * وكان التذكيرُ اليوميُّ بعد الموعد يُطلَق بحدث «قبل الموعد» نفسِه، **فوصل كارتٌ
     * فات موعدُه من ثلاثة أيام بجملة «موعده قرّب»** — رسالةٌ تكذب.
     */
    "cards.reminder.overdue": {
        titleKey: "notify.cards.overdueTitle",
        bodyKey: "notify.cards.overdueBody",
        link: "/cards/{id}",
        params: ["days"],
    },
    "cards.escalation.late": {
        titleKey: "notify.cards.escalationTitle",
        bodyKey: "notify.cards.escalationBody",
        link: "/cards/{id}",
    },
    /**
     * **السلسلةُ المتعثّرة** — مهمةٌ متكرّرة تتراكم نسخُها بلا إنجاز (قرار شادي ٢٠٢٦-١٠-٢٧).
     */
    "cards.recurrence.stalled": {
        titleKey: "notify.cards.stalledTitle",
        bodyKey: "notify.cards.stalledBody",
        link: "/cards/{id}",
        params: ["missed"],
    },
    "cards.attachment.added": {
        titleKey: "notify.cards.attachedTitle",
        bodyKey: "notify.cards.attachedBody",
        link: "/cards/{id}",
    },
    "cards.recurrence.spawned": {
        titleKey: "notify.cards.recurrenceSpawnedTitle",
        bodyKey: "notify.cards.recurrenceSpawnedBody",
        link: "/cards/{id}",
        params: ["due"],
    },
    "clients.export.ready": {
        titleKey: "notify.clients.exportReadyTitle",
        bodyKey: "notify.clients.exportReadyBody",
        link: "/clients/{id}",
    },
    "clients.export.failed": {
        titleKey: "notify.clients.exportFailedTitle",
        bodyKey: "notify.clients.exportFailedBody",
        link: "/clients/{id}",
        params: ["code"],
    },
    "plans.item.assigned": {
        titleKey: "notify.plans.assignedTitle",
        bodyKey: "notify.plans.assignedBody",
        link: "/plan-items/{id}",
        params: ["due"],
    },
    "plans.item.updated": {
        titleKey: "notify.plans.updatedTitle",
        bodyKey: "notify.plans.updatedBody",
        link: "/plan-items/{id}",
    },
    "plans.item.state_changed": {
        titleKey: "notify.plans.stateTitle",
        bodyKey: "notify.plans.stateBody",
        link: "/plan-items/{id}",
    },
    /**
     * **خبرُ من يسجّل قرار العميل** — ونصُّه غيرُ نصّ الموظف.
     *
     * وفي v2 كان هذا حدثاً منفصلاً يُكتب بيد لأن نصَّ الموظف ورابطَه `/app/...`
     * **لا يصلحان لجهة اتصالٍ في البورتال**. وهنا يُعلَن إعلاناً ثانياً على نفس
     * العملية، فيأتي الجمهوران من فعلٍ واحد.
     */
    "plans.item.awaiting_client": {
        titleKey: "notify.plans.awaitingTitle",
        bodyKey: "notify.plans.awaitingBody",
        link: "/plan-items/{id}",
    },
    "plans.item.client_decided": {
        titleKey: "notify.plans.decidedTitle",
        bodyKey: "notify.plans.decidedBody",
        link: "/plan-items/{id}",
    },
    "plans.item.withdrawn": {
        titleKey: "notify.plans.withdrawnTitle",
        bodyKey: "notify.plans.withdrawnBody",
        link: "/plan-items/{id}",
    },
    "plans.item.cancelled": {
        titleKey: "notify.plans.cancelledTitle",
        bodyKey: "notify.plans.cancelledBody",
        link: "/plan-items/{id}",
    },
    /**
     * **إشعاراتُ المهمة لصاحبها — ورابطُها يفتح عنصرَها.**
     *
     * فالمهمةُ كيانُ الإشعار، ومشاركُها صاحبُها وحده: المونتيرُ لا يُبلَّغ أن كفرَ
     * زميله رجع. والمراجعون يُبلَّغون بالتسليم بنطاقهم.
     */
    "plans.task.assigned": {
        titleKey: "notify.plans.taskAssignedTitle",
        bodyKey: "notify.plans.taskAssignedBody",
        link: "/plan-tasks/{id}",
        params: ["task", "due"],
    },
    "plans.task.delivered": {
        titleKey: "notify.plans.taskDeliveredTitle",
        bodyKey: "notify.plans.taskDeliveredBody",
        link: "/plan-tasks/{id}",
        params: ["task"],
    },
    "plans.task.approved": {
        titleKey: "notify.plans.taskApprovedTitle",
        bodyKey: "notify.plans.taskApprovedBody",
        link: "/plan-tasks/{id}",
        params: ["task"],
    },
    "plans.task.returned": {
        titleKey: "notify.plans.taskReturnedTitle",
        bodyKey: "notify.plans.taskReturnedBody",
        link: "/plan-tasks/{id}",
        params: ["task", "reason"],
    },
    "plans.exception.resolved": {
        titleKey: "notify.plans.exceptionTitle",
        bodyKey: "notify.plans.exceptionBody",
        link: "/plan-items/{id}",
    },
    "plans.exception.escalated": {
        titleKey: "notify.plans.escalatedTitle",
        bodyKey: "notify.plans.escalatedBody",
        link: "/plan-items/{id}",
        params: ["hours"],
    },
    "plans.media.added": {
        titleKey: "notify.plans.mediaTitle",
        bodyKey: "notify.plans.mediaBody",
        link: "/plan-items/{id}",
    },
    "plans.comment.added": {
        titleKey: "notify.plans.commentTitle",
        bodyKey: "notify.plans.commentBody",
        link: "/plan-items/{id}",
    },
    "plans.comment.mentioned": {
        titleKey: "notify.plans.mentionTitle",
        bodyKey: "notify.plans.mentionBody",
        link: "/plan-items/{id}",
    },
    "clients.portal.changed": {
        titleKey: "notify.clients.portalTitle",
        bodyKey: "notify.clients.portalBody",
        link: "/clients/{id}",
    },
    "clients.publishing.changed": {
        titleKey: "notify.clients.publishingTitle",
        bodyKey: "notify.clients.publishingBody",
        link: "/clients/{id}",
    },
    "platform.backup.failed": {
        titleKey: "notify.platform.backupFailedTitle",
        bodyKey: "notify.platform.backupFailedBody",
        link: "/health",
    },
    "storage.orphan.found": {
        titleKey: "notify.storage.orphanTitle",
        bodyKey: "notify.storage.orphanBody",
        params: ["count"],
        link: "/storage/orphans/{id}",
    },
    // ═══════════ البورتال — **أحداثٌ يطلقها العميل، ونصُّها للوكالة** ═══════════
    /**
     * وقرارُ العميل من البورتال حدثٌ **بنصٍّ خاصّ**: «العميل قرّر» لا «قرار نيابة
     * اتسجّل». فالفاعلُ هو العميل نفسه، والفرقُ يُقرأ في الصندوق.
     */
    "portal.item.decided": {
        titleKey: "notify.portal.decisionTitle",
        bodyKey: "notify.portal.decisionBody",
        link: "/plan-items/{id}",
    },
    "portal.item.edit_requested": {
        titleKey: "notify.portal.editRequestTitle",
        bodyKey: "notify.portal.editRequestBody",
        link: "/plan-items/{id}",
    },
    "portal.comment.added": {
        titleKey: "notify.portal.commentTitle",
        bodyKey: "notify.portal.commentBody",
        link: "/plan-items/{id}",
    },
    /**
     * **وما يصل العميل نفسه** — ورابطُه بورتاليّ لا داخليّ.
     *
     * فجهةُ الاتصال لا تملك `/plan-items/:id` الداخلي، ولو حمل إشعارُها ذلك
     * الرابط لانتهى بها إلى رفض. والقوقعةُ تُختار بنوع الحساب، **والرابطُ كذلك**.
     */
    "portal.item.awaiting_decision": {
        titleKey: "notify.portal.awaitingTitle",
        bodyKey: "notify.portal.awaitingBody",
        link: "/portal/items/{id}",
    },
};
export const NOTIFICATION_EVENTS = Object.keys(notificationDefinitions);
export function isKnownEvent(event) {
    return event in notificationDefinitions;
}
/**
 * التعريف، **أو رفضٌ صريح**.
 *
 * حدثٌ بلا تعريف عطبٌ برمجيّ: إشعارٌ بلا نصّ لا يُعرَض على إنسان. والصمت عنه
 * يعني إشعاراً يختفي — وهو ما لا يُكتشف إلا بشكوى.
 */
export function notificationDefinition(event) {
    return notificationDefinitions[event];
}
/** يبني الرابط العميق لسجلٍّ بعينه */
/**
 * **رابطُ تنبيهِ التجربة — يعود إلى زرّه في «حسابي».**
 *
 * وليس حدثاً من السجلّ فلا يحمل `link` في تعريف، **فيُعلَن هنا** ليقرأه المرسِلُ
 * في السيرفر وبوابةُ الوجهات في الواجهة معاً — ورابطٌ يُكتب حرفياً في موضعين
 * يفترق يوماً فيُنقَر التنبيهُ ولا يفتح شيئاً.
 */
export const PUSH_TEST_LINK = "/profile";
export function deepLinkFor(event, subjectId) {
    const template = notificationDefinitions[event].link;
    return subjectId === null ? template.replace("/{id}", "") : template.replace("{id}", subjectId);
}
//# sourceMappingURL=registry.js.map